import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button } from "grommet";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import StatDetails from "./StatDetails";
import { createStat, CreateStatRequest } from "./StatsStore";

const plus = <FontAwesomeIcon icon={["fad", "plus"]}></FontAwesomeIcon>;
const xmark = <FontAwesomeIcon icon={["fad", "xmark"]}></FontAwesomeIcon>;

const CreateStat = () => {
    let [stat, setStat] = React.useState(new CreateStatRequest());

    let [isCreating, setIsCreating] = React.useState(false);

    let [error, setError] = React.useState("");

    const navigate = useNavigate();

    let create = () => {
        setIsCreating(true);
        createStat({ ...stat }).then(
            (response) => {
                navigate(`/stats`);
            },
            (error) => {
                setError(error);
            }
        );
    };

    const onChange = (updatedStat) => {
        setStat({ ...stat, ...updatedStat });
    };

    return (
        <div>
            <h1>Create Stat</h1>
            <Box>
                <StatDetails stat={stat} isBusy={isCreating} onChange={onChange}></StatDetails>
                <Button primary onClick={create} disabled={isCreating || !stat.name} label="Create"></Button>
                <Box>{error && <pre>{JSON.stringify(error, null, 2)}</pre>}</Box>
            </Box>
        </div>
    );
};

export default CreateStat;
